/*
 * Copyright (c) 2019 Signum+ Software & Facility GmbH
 * Author: jahn@signum-plus.at
 */

// json module imports either resolve to
// { ... content ... } or to { default: { ... content ... } }
// depending on tsconfig;
export function getJsonExport<T>(source: T | { default: T }): T {
  return 'default' in source ? source.default : source;
}
